export enum ErrorTypes {
  SelectedRoomIsAlreadyOccupied = 'SelectedRoomIsAlreadyOccupied'
}



// WEBPACK FOOTER //
// ./src/shared/errors/ErrorTypes.ts